import React from 'react';
import * as S from './DropDownList.styled';
import { ParagraphWithTooltip } from 'components';
import { Palette } from 'config';

export const CampaignItem = ({ handleClickOnItem, rowData, isActiveCamp, searchValue$ }) => {
  return (
    <S.CampaignItem
      onClick={() => handleClickOnItem(rowData)}
      key={rowData._campaignid}
      isActive={isActiveCamp(rowData._campaignid)}
    >
      <ParagraphWithTooltip
        style={{
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: '20px',
          color: '#0F172A',
        }}
        text={rowData?.campaign}
        search={searchValue$.value}
        isHighlight
        highlightStyle={{ color: `${Palette.PrimaryGray._900}`, fontWeight: '500' }}
      />
      <S.CampNumberBox>
        <S.Text>ID:</S.Text>
        <ParagraphWithTooltip
          style={{
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '16px',
            color: '#334155',
          }}
          text={rowData?._campaignid?.toString()}
          search={searchValue$.value}
          isHighlight
          highlightStyle={{ color: `${Palette.PrimaryGray._900}`, fontWeight: '500' }}
        />
      </S.CampNumberBox>
    </S.CampaignItem>
  );
};
